import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import InfoesIcon from '../Icons/InfoesIcon';
import ErroreIcon from '../Icons/ErroreIcon';
import SuccessoIcon from '../Icons/SuccessoIcon';
import Tooltip from '../Tooltip/Tooltip';

/**
Il componente è stato pensato per visualizzare informazioni
aggiuntive riguardo ad una limitata funzionalità o sezione di interfaccia.
 */
const InfoTooltip = ({
  children, left, right, top, type, className,
}) => {
  const Icon = useMemo(() => {
    if (type === 'alarm' || type === 'warning') {
      return ErroreIcon;
    }
    if (type === 'success') {
      return SuccessoIcon;
    }
    return InfoesIcon;
  }, [type]);

  const classes = cns(
    'infoTooltip--icon',
    `infoTooltip--${type}`,
    className,
  );

  return (
    <Tooltip
      className={classes}
      content={children}
      left={left}
      right={right}
      top={top}
    >
      <Icon data-clickable="false" />
    </Tooltip>
  );
};

InfoTooltip.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.node,
  /** Indica se aprire il contenuto spostato verso sinistra */
  left: PropTypes.bool,
  /** Indica se aprire il contenuto spostato verso destra */
  right: PropTypes.bool,
  /** Mostra il contenuto sopra */
  top: PropTypes.bool,
  /** Indica la tipologia del tooltip */
  type: PropTypes.oneOf(['info', 'alarm', 'warning', 'success']),
};

InfoTooltip.defaultProps = {
  className: '',
  children: null,
  left: false,
  right: false,
  top: false,
  type: 'info',
};

export default InfoTooltip;
